import { styled } from '@material-ui/core';

const Flexbox = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
  marginBottom: '8px',
});

export default Flexbox;
